module.exports = __webpack_public_path__ + "static/world-map-12bb12745e3a99b6aee2cede9f54e29e.png";